var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.facet.name
    ? _c(
        "div",
        { staticClass: "card border-0" },
        [
          _c("div", { staticClass: "h3 title py-0 sr-only" }, [
            _vm._v(_vm._s(_vm.facetName)),
          ]),
          _vm._v(" "),
          _vm.facet.type === "price"
            ? _c("div", [_c("item-filter-price")], 1)
            : _c("vue-bootstrap-typeahead", {
                staticClass: "p-3",
                attrs: {
                  "show-items-on-empty-query": "",
                  "min-matching-chars": 1,
                  "max-matches": 100,
                  data: _vm.facets,
                  serializer: (s) => s.name,
                  placeholder: _vm.facetName,
                },
                on: {
                  hit: function ($event) {
                    return _vm.updateFacet($event)
                  },
                },
                model: {
                  value: _vm.query,
                  callback: function ($$v) {
                    _vm.query = $$v
                  },
                  expression: "query",
                },
              }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }